export const parseOportunityMrpData = (data: any): any[] => {
  const { resumos } = data

  const rows: any[] = []

  for (const resumo of resumos) {
    rows.push({
      descricao: resumo.tipo,
      ...resumo.valores.map((item: any, n: number) => {
        const key = `meses-${n + 1}`

        return {
          [key]: item.valor.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        }
      })
    })
  }

  return rows
}
